import { Route } from "react-router-dom";
import ConstanciasER from "../pages/academics/ContanciasER";
import Transparencia from "../pages/academics/Transparencia";

const academicRoutes = [
  {
    name: "Prodep",
    path: "/",
    // path: "/constancias",

    element: <ConstanciasER />,
  },
  {
    name: "Tranparencia",
    path: "/transparencia",
    // path: "/constancias",

    element: <Transparencia />,
  },
];

export const AcademicRoutes = () => {
  return academicRoutes.map((route, index) => {
    return (
      <Route key={route} path={route.path} element={route.element}></Route>
    );
  });
};
